// Neutral dossier used by the landing passport preview.
//
// It deliberately carries no real maison, no logo and no personal identity: the
// preview shows what a passport *documents* (custody, condition, continuity),
// it never advertises a brand. Descriptive values go through `t` so the demo
// stays bilingual; codes and numbers stay literal.
//
// The shape mirrors the API payload — `event_type` / `actor_type` codes and ISO
// dates — so a real dossier can replace this fixture without touching
// PassportPreview.
export const buildDemoPassport = (t) => ({
  identity: {
    name: t("passportPreview.demo.name"),
    maker: t("passportPreview.demo.maker"),
    year: "1998",
    material: t("passportPreview.demo.material"),
    reference: "4113-02",
  },
  // No AUTHENTICATION event on purpose: Provena records traceability, it does
  // not authenticate.
  custody: [
    { id: "c1", event_date: "1998-06-12", event_type: "REGISTRATION", actor_type: "proprietaire" },
    { id: "c2", event_date: "2007-03-04", event_type: "SERVICE", actor_type: "horloger" },
    { id: "c3", event_date: "2014-11-21", event_type: "OWNERSHIP_TRANSFER", actor_type: "marchand" },
    { id: "c4", event_date: "2023-09-08", event_type: "SERVICE", actor_type: "horloger" },
  ],
  condition: {
    assessed_at: "2023-09-08",
    tags: [
      { key: "case", state: "worn" },
      { key: "movement", state: "serviced" },
      { key: "bracelet", state: "intact" },
    ],
  },
  continuity: { owner_count: 4 },
});

export default buildDemoPassport;
